<div class="step-title">Bank Information</div>
<div class="step-description">Use the options below to link the bank account to deposit funds.</div>

<div class="row justify-content-center d-flex mb-3">
    <div class="col-12 col-md-5 mb-3">
    <div class="row mb-3">
      <div class="col-12">
        <div class="icon-container align-items-start"> <app-icon-bank></app-icon-bank></div>
      </div>

      <div class="col-12">
        <app-ngx-plaid-link-wrapper
          [plaid]="plaid"
          (Success)="onPlaidSuccess($event)"
          (Exit)="onPlaidExit($event)"
          (Load)="onPlaidLoad($event)"
          (Event)="onPlaidEvent($event)"
          (Click)="onPlaidClick($event)"
        ></app-ngx-plaid-link-wrapper>
      </div>
    </div>
  </div>

  <div class="col-12 col-md-7 mb-3">
    <div class="row mb-3">
      <div class="col-12">
        <div class="icon-container align-items-end"><app-icon-cheque></app-icon-cheque></div>
      </div>

      <div class="col-12">
        <button class="action-button btn btn--paybee btn--purple w-100" (click)="onAccountRoutingNumber()"> Account/Routing Number </button>
      </div>
    </div>
  </div>
</div>
